import { render } from "./PreferenceCard.vue?vue&type=template&id=4cd30fcf&scoped=true"
import script from "./PreferenceCard.vue?vue&type=script&lang=js"
export * from "./PreferenceCard.vue?vue&type=script&lang=js"

import "./PreferenceCard.vue?vue&type=style&index=0&id=4cd30fcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd30fcf"]])

export default __exports__